import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
import React from 'react';

interface ImageListItemProps {
    image: string;
    imageSize?: 'small' | 'large' | 'auto';
    onImageClick?: () => void;
    showDetails?: boolean;
    className?: string;
    onDelete?: () => void;
    disabled?: boolean;
}

const ImageListItem = ({ image, imageSize = 'small', onImageClick, showDetails = true, className, onDelete, disabled }: ImageListItemProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={classNames(className, 'cursor-pointer border rounded flex px-2 py-1 mt-1 bg-gray-100 text-gray-500 text-sm', {
                'items-stretch': imageSize === 'auto',
                'items-center': imageSize !== 'auto',
                'hover:opacity-60  transition-opacity': !!onImageClick,
            })}
        >
            {onImageClick ? (
                <button
                    aria-label={'Hochgeladenes Ablesefoto öffnen'}
                    onClick={() => onImageClick && onImageClick()}
                    className={classNames('w-full', { 'h-full': imageSize === 'auto' })}
                >
                    <img
                        aria-label={'Thumbnail'}
                        src={image}
                        alt={'Hochgeladenes Ablesefoto'}
                        className={classNames('object-cover rounded', {
                            'h-8 w-8': imageSize === 'small',
                            'h-24 w-24': imageSize === 'large',
                            'h-full w-full': imageSize === 'auto',
                        })}
                    />
                </button>
            ) : (
                <div>
                    <img
                        aria-label={'Thumbnail'}
                        src={image}
                        alt={'Hochgeladenes Ablesefoto'}
                        className={classNames('object-cover rounded', {
                            'h-8 w-8': imageSize === 'small',
                            'h-24 w-24': imageSize === 'large',
                            'h-full w-full': imageSize === 'auto',
                        })}
                    />
                </div>
            )}
            {showDetails && (
                <>
                    <div className={'ml-2 flex-1 leading-none'}>
                        {t('jobs.details.imageUploaded')}
                        <br />
                        <small aria-label={'Dateigröße'}>{(image.length / 1024).toFixed(0)} kB</small>
                    </div>
                    <div className={'w-6 text-green-500'}>
                        <Icon aria={{ 'aria-hidden': true }} path={Icon.Path.mdiCheck} className={'h-5 w-5'} />
                    </div>
                </>
            )}
            {onDelete && (
                <button
                    type={'button'}
                    aria-label={t('jobs.details.buttons.removeImage')}
                    className={classNames('ml-2 flex-shrink-0 w-6 flex items-center justify-center text-gray-400 hover:text-red-500 transition-colors', {
                        'opacity-40 pointer-events-none': disabled,
                    })}
                    onClick={() => onDelete()}
                >
                    <Icon aria={{ 'aria-hidden': true }} path={Icon.Path.mdiTrashCanOutline} className={'h-5 w-5'} />
                </button>
            )}
        </div>
    );
};

export default ImageListItem;
